import { ChangeDetectorRef, Component, Renderer2, Output, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { GlobalsService } from '../../services/globals.service';
import * as _ from 'lodash';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { AppClaims } from '../../models/AppClaims';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { BaseGridEditLineComponent } from '../../base-components/base-grid-editline.component';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { DashboardService } from '../../services/dashboard.service';
import { CreditMemoWidgetUser } from '../../models/CreditMemoWidgetUser';
import { CommonFunctions } from '../../static/common-functions';
import { SaveMode } from '../../enums/SaveMode';
import { BaseMessageInfo } from '../../models/BaseMessageInfo';
import { DivisionBus } from '../../models/DivisionBus';
import { Subscription } from 'rxjs';
import { DQOIReferenceData } from '../../models/DQOIReferenceData';

@Component({
    selector: 'user-credit-memo',
    templateUrl: './user-credit-memo.component.html',
    styleUrls: ['./user-credit-memo.component.scss']
})
export class UserCreditMemoComponent extends BaseGridEditLineComponent<any, null, null> implements OnDestroy, OnInit {

    constructor(globals: GlobalsService, dashboardService: DashboardService, renderer: Renderer2, featureFlagService: FeatureFlagService, cd: ChangeDetectorRef, qry_rd: DQOIReferenceDataQuery) {
        super(globals, renderer, cd, featureFlagService);
        this.dashSrv = dashboardService;
        this.className = 'CreditMemoWidgetUser';
        this.qry_rd = qry_rd;
        this.saveMode = SaveMode.individual;
        this.callSaveIndividualInsteadOfSave = true;
        this.subs_dataRef = this.qry_rd.ensureRefDataIsLoaded(this.globals.companyId).subscribe();
        this.subs_dataRefUpdated = this.qry_rd.referenceDataUpdated.subscribe((data: DQOIReferenceData) => {
            this.referenceData = data;
        });

    }
    subs_dataRef: Subscription;
    subs_dataRefUpdated: Subscription;
    dashSrv: DashboardService;
    showUserSearch: boolean = false;

    editForm: UntypedFormGroup
    active: boolean = false;
    qry_rd: DQOIReferenceDataQuery;
    divisions: DivisionBus[];
    userRegions: any[];

    @Output() toggleUserCreditMemoDisplay: EventEmitter<boolean> = new EventEmitter<boolean>();

    ngOnInit(): void {
        this.dataLoading = true;
        this.getDataGrid();
        this.dashSrv.getDivisions().subscribe(data => {
            if (CommonFunctions.hasArrayValue(data.resultList)) {
                let arr = [];
                for (let i = 0; i < data.resultList.length; i++) {
                    let dataObject = new DivisionBus(data.resultList[i]);
                    arr.push(dataObject);
                }
                this.divisions = arr;
            }
        });
    }
    override ngOnDestroy(): void {
        super.ngOnDestroy();
        CommonFunctions.unsubscribe(this.subs_dataRef);
        CommonFunctions.unsubscribe(this.subs_dataRefUpdated);
    }

    getDataGrid() {
        this.dashSrv.getCreditMemoWidgetUserGrid().subscribe({
            next: data => {
                if (CommonFunctions.hasArrayValue(data.resultList)) {
                    let arr = [];
                    for (let i = 0; i < data.resultList.length; i++) {
                        let dataObject = new CreditMemoWidgetUser(data.resultList[i]);
                        arr.push(dataObject);
                    }
                    this.ListData = arr;
                }
                else if (!data.success) {
                    this.notify("Error fetching credit memo profiles. " + data.message, "E", false);
                }
            },
            error: err => {
                this.dataLoading = false;
                this.notify("Error fetching credit memo profiles. " + err.message, "E", false);
            },
            complete: () => {
                this.dataLoading = false;
            }
        });
    }

    getReferenceRegionName(id: any) {
        return this.referenceData.regions.find(e => e.value == id);
    }
    getReferenceDivisionName(id: any) {
        return this.referenceData.divisions.find(e => e.value == id);
    }

    setFormRegion() {
        let regionList: any[] = [];
        if (this.selectedData != undefined && this.selectedData.regionIds != null) {
            this.selectedData.regionIds.forEach(id => {
                let region = this.getReferenceRegionName(id);
                regionList.push(region);
            });
        }
        return regionList;
    }
    setFormDivision() {
        let divisionList: any[] = [];
        if (this.selectedData.divisionIds != undefined && this.selectedData.divisionIds != null) {
            this.selectedData.divisionIds.forEach(id => {
                let division = this.getReferenceDivisionName(id);
                divisionList.push(division);
            });
        }

        return divisionList;
    }
    setForm() {
        this.userRegions = this.selectedData.regionIds;
        this.editForm.patchValue({
            Divisions: this.setFormDivision(),
            Regions: this.setFormRegion(),
            LegalName: this.selectedData.legalName,
            CreditLimit: this.selectedData.creditLimit != undefined ? this.selectedData.creditLimit : null
        });
    }

    createForm() {
        this.editForm = new UntypedFormGroup({
            'LegalName': new UntypedFormControl(),
            'Divisions': new UntypedFormControl(),
            'Regions': new UntypedFormControl(),
            'CreditLimit': new UntypedFormControl()
        });
    }

    userSelected(event: any) {
        if (event != null) {
            this.selectedData.legalName = event.legalName;
            this.selectedData.userId = event.userId;
            this.createForm();
            this.grid.addRow(this.editForm);
            this.setForm();
            this.showUserSearch = false;
        }
        else {
            this.showUserSearch = false;
        }
        this.genericCloseCtrl(null);
    }

    public addHandler(): void {
        super.addHandler();
        this.genericOpenCtrl(null);
        this.showUserSearch = true;
    }

    saveIndividual(dataObj: CreditMemoWidgetUser): Promise<BaseMessageInfo> {
        let listRegions: string[] = [];
        let listDivision: string[] = [];
        this.dataLoading = true;
        this.editForm.controls.Regions.value.forEach(e => {
            listRegions.push(e.value);
        });

        this.editForm.controls.Divisions.value.forEach(e => {
            listDivision.push(e.value);
        });

        let requestData: CreditMemoWidgetUser = new CreditMemoWidgetUser();
        requestData.userId = this.selectedData.userId;
        requestData.regionIds = listRegions;
        requestData.divisionIds = listDivision;
        requestData.creditLimit = this.editForm.controls.CreditLimit.value;
        requestData.legalName = this.selectedData.legalName;

        if ((!requestData.regionIds || requestData.regionIds.length == 0) && (!requestData.divisionIds || requestData.divisionIds.length == 0)) {
            this.removeLocal(this.selectedData);
            this.dataLoading = false;
        }
        else {
            let retInfo: BaseMessageInfo = new BaseMessageInfo();
            return new Promise((resolve, reject) => {
                this.dashSrv.saveCreditMemoWidgetUser(requestData).toPromise().then((data) => {
                    retInfo.primaryReturn = requestData;
                    this.notify('User ' + requestData.legalName + ' was saved successfully.');
                    this.dataLoading = false;
                    resolve(retInfo);
                });
            });
        }

    }

    deleteIndividual(data: CreditMemoWidgetUser) {
        this.dataLoading = true;
        if (data.hasId) {
            this.dashSrv.deleteCreditMemoWidgetUser(data.userId).subscribe((dataObj: BaseMessageInfo) => {
                if (!dataObj.saveError) {
                    this.deleteSuccess(data);
                    this.removeLocal(data);
                }
                else {
                    this.deleteError(data, dataObj.message);
                }
            });
        }
        else {
            this.closeEditor();
        }

        this.dataLoading = false;
    }

    hide() {
        this.toggleUserCreditMemoDisplay.emit();
    }

    cancel() {
        this.hide();
    }
    close() {
        this.hide();
    }
    public show(id: any) {
        this.toggleUserCreditMemoDisplay.emit();
    }

    regionChanged(e) {
        if (!this.userRegions || e.length > this.userRegions.length) {
            let regionId = "";

            if(this.userRegions){
                regionId = e.find(x => this.userRegions.findIndex(y => y == x.value) == -1).value;
            }
            else{
                regionId = e[0].value;
            }

            this.addRegionDivisions(regionId);
        }
        else {
            //find the removed value and remove all divisions in that region
            let regionToRemove = this.userRegions.find(x => e.findIndex(y => y.value == x) == -1);
            this.removeRegionDivisions(regionToRemove);
        }

        this.userRegions = e.map((x) => x.value);
    }

    addRegionDivisions(regionId: string) {
        if (this.selectedData) {
            let divisionsToAdd = this.divisions.filter(x => x.regionId == regionId);

            let divisionIds: any[] = divisionsToAdd.map((x) => { return { value: x.divisionId, description: x.divisionName } });

            //if we have any divisionIds, make sure we're only adding ones not present in the array
            if (this.selectedData.divisionIds) {
                this.selectedData.divisionIds.forEach((id) => {
                    if (divisionIds.findIndex(x => x == id) == -1) {
                        divisionIds.push({ value: id, description: this.referenceData.divisions.find(x => x.value == id).description });
                    }
                });
            }

            this.editForm.patchValue({
                Divisions: divisionIds
            });
        }
    }

    removeRegionDivisions(regionId: string) {
        if (this.selectedData) {
            let divisionsToRemove = this.divisions.filter(x => x.regionId == regionId).map((x) => { return x.divisionId });

            //collect all the divisions that need to be kept
            if (this.selectedData.divisionIds) {
                var divisionIds = this.selectedData.divisionIds
                    .filter(x => !divisionsToRemove.includes(x))
                    .map((y) => { return { value: y, description: this.referenceData.divisions.find(x => x.value == y).description } });
            }

            //assign the keepers to the patchvalue
            this.editForm.patchValue({
                Divisions: divisionIds
            });
        }
    }
}

